import React, { CSSProperties } from 'react';
import clsx from 'clsx';

import { Floater as StyledFloater } from './wrappers';

export interface IFloater {
  articleNumber?: string;
  badgeLabel?: string;
  badgeTail?: string;
  badgeStyle?: CSSProperties;
  children?: React.ReactNode;
  hasImage?: boolean;
  heading?: string;
  image?: string;
  link?: string;
  posLeft: number;
  posLeftMobile?: number;
  posTop: number;
  posTopMobile?: number;
  preHeading?: string;
  price?: IPrice;
  imageSizeMobile?: string;
  imageSizeDesktop?: string;
  textColor?: string;
  inPanel?: boolean;
}

const Floater = ({
  children,
  hasImage,
  posTop,
  posLeft,
  posTopMobile,
  posLeftMobile,
  imageSizeMobile,
  imageSizeDesktop,
  textColor,
  inPanel,
}: IFloater) => (
  <StyledFloater
    posTop={posTop}
    posLeft={posLeft}
    posTopMobile={posTopMobile}
    posLeftMobile={posLeftMobile}
    textColor={textColor}
    inPanel={inPanel}
    className={clsx(
      hasImage && imageSizeMobile && `m-size-${imageSizeMobile}`,
      hasImage && imageSizeDesktop && `d-size-${imageSizeDesktop}`,
    )}>
    {children}
  </StyledFloater>
);

export default Floater;
